<script setup>
import {__} from "../../../../assets/javascripts/library";
import PdfViewer from "../../../../assets/components/PdfViewer.vue";
import DistanceAllowance from "../DistanceAllowance.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  modeShow: {
    type: Boolean,
    required: true,
  }
})

const emit = defineEmits(["accept", "deny", "fix", "reopen"])
</script>

<template>
<span id="invoice_details_header">
    <table>
      <tr>
        <td>{{__('Name', 'mareike')}}:</td>
        <td v-if="modeShow">{{props.data.name}}</td>
        <td v-else style="width: 300px;">{{props.data.name}}</td>

        <td v-if="modeShow" style="width: 250px;">{{__('Cost unit', 'mareike')}}</td>
        <td v-else style="width: 300px;">{{__('Cost unit', 'mareike')}} ({{__('original', 'mareike')}})</td>

        <td>{{props.data.cost_unit_name}}</td>
        <td rowspan="4">
          <button
              v-if="props.data.status === 'NEW' && modeShow"
              @click="emit('accept')"
              class="button mareike-button mareike-accept-button"
          >
            {{__('Accept invoice', 'mareike') }}
          </button>
          <button v-if="props.data.status === 'DENIED' && modeShow"
                  @click="emit('reopen')"
                  class="button mareike-button mareike-accept-button"
          >
            {{__('Reopen invoice', 'mareike') }}
          </button>
          <br />

          <button
              v-if="props.data.status === 'NEW' && modeShow"
              @click="emit('fix')"
              class="button mareike-button mareike-fix-button"
          >
            {{__('Deny invoice and fix', 'mareike') }}
          </button><br />

          <button
              v-if="props.data.status === 'NEW' && modeShow"
              @click="emit('deny')"
              class="button mareike-button mareike-deny-button"
          >
            {{__('Deny invoice', 'mareike') }}
          </button>
        </td>
      </tr>

      <!-- Rest der Tabelle bleibt unverändert -->
      <tr>
        <td>{{__('E-Mail', 'mareike')}}:</td>
        <td>{{props.data.email}}</td>
        <td>
          {{__('Invoice number', 'mareike')}}
          <label v-if="!modeShow"> ({{__('original', 'mareike')}})</label>:
        </td>

        <td>{{props.data.invoice_number}}</td>
      </tr>
      <tr>
        <td>{{__('Account owner', 'mareike')}}:</td>
        <td>{{props.data.account_owner}}</td>
        <td>
          {{__('Invoice type', 'mareike')}}
          <label v-if="!modeShow"> ({{__('original', 'mareike')}})</label>:
        </td>
        <td>{{props.data.type}}<label v-if="props.data.type === __('Other', 'mareike')"> ({{ props.data.type_other}})</label></td>
      </tr>
      <tr>
        <td>{{__('Account IBAN', 'mareike')}}:</td>
        <td>{{props.data.account_iban}}</td>
        <td>{{__('Total amount', 'mareike')}}
          <label v-if="!modeShow"> ({{__('original', 'mareike')}})</label>:
        </td>
        <td><strong>{{props.data.amount}}</strong></td>
      </tr>
      <tr>
        <td>{{__('Invoice status', 'mareike')}}:</td>
        <td>{{props.data.status}}</td>
        <td>{{__('Notices', 'mareike')}}:</td>
        <td>
          <span v-if="props.data.status === 'DENIED' || props.data.status === 'DENIED_EXPORTED'">
            {{props.data.denied_reason}}
          </span>
          <span v-else>{{props.data.comment}}</span>
        </td>
      </tr>
    </table>
  </span>
</template>

<style scoped>

</style>